import React from "react";
import CarNavbar from "../components/CarNavbar";
import { useLocation } from "react-router-dom";
import shareIcon from "../img/shareIcon.png";

const Section1 = ({ contenuti, breadCrumbs }) => {
    const location = useLocation();
  const greenPaths = [
    ,
  ];
  const isGreenGlobal = greenPaths.includes(location.pathname);

  return (
    <>
      {contenuti.map((content, index) => {
        const { titolo1, titolo2, callToAction, link, immagineBg, descrizione_it } = content;
        return (

          <div
            key={index}
            className=" h-nav d-flex flex-column position-relative"
            style={{
              backgroundImage: `url(${immagineBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            
            
            <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>

            <CarNavbar />
            <div className=" d-flex h-nav align-items-center ps-5 gap-4 z-2">
              <img
                src={shareIcon}
                alt="Share Icon"
                className="img-fluid d-block d-md-none" // Show on mobile
                style={{ width: "48px", height: "48px" }}
              />
              <img
                src={shareIcon}
                alt="Share Icon"
                className="img-fluid d-none d-md-block" // Show on desktop
                style={{ width: "128px", height: "128px" }}
              />
              <div>
                <p className="title-header-desktop d-none d-md-block">
                  {titolo1}{}
                </p>
                <p className="title-header-desktop d-none d-md-block">
                  {titolo2}
                </p>

                <p className="title-header-mobile d-block d-md-none">
                  {titolo1} {titolo2}
                </p>
                <p className="text-white text-21">
                  {descrizione_it}
                </p>

                <div className="mt-4 d-none d-md-flex">
                  {/* Condizione per scegliere se mostrare il link o il sottotitolo */}
                  {callToAction ? (
                    <a href={link} className="btn btn-two text-uppercase">
                      {callToAction}
                    </a>
                  ) : (
                    <p className="subtitle-text">{breadCrumbs}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="position-absolute w-100 navbar-onda">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1440 50"
                preserveAspectRatio="none"
                className="w-100"
              >
                <path
                  fill= "#fff"
                  d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50C320,50,160,50,80,50L0,50Z"
                ></path>
              </svg>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Section1;
